import { resolve } from "inversify-react";
import * as React from "react";
import { connect } from "react-redux";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { Link } from "react-router-dom";
import { actions as homeActions } from "../../../actions/home.actions";
import { actions } from "../../../actions/main.actions";
import { actions as nameActions } from "../../../actions/name.actions";
import Button from "../../../core/ui/button";
import Divider from "../../../core/ui/divider";
import GenericDropDown from "../../../core/ui/generic-dropdown";
import Icon from "../../../core/ui/icon";
import ArtsDataService from "../arts.data.service";
import FavouriteButtonProps from "./favourite";
import Fade from "react-reveal/Fade";
import { FacebookShareButton, TwitterShareButton } from "react-share";
import EditionCombo from "../../../core/ui/data-component/edition-select";
import Grid, { Col } from "../../../core/ui/grid";
import Modal from "../../../core/ui/modal";
import BlockchainService from "../../../services/blockchain.service";
import HttpService from "../../../services/http.service";
import IdentityService from "../../../services/identity.service";
import ToastService from "../../../services/toast.service";
import { IApplicationState } from "../../../typings";
import images from "../../../assets/images";

interface IArtHeaderProps {
    canEdit?: boolean;
    canDelete?: boolean;
    canFavourite?: boolean;
    canClone?: boolean;
    canShare?: boolean;
    id: string;
    onlyActions?: boolean;
    url: string;
    edit?: boolean;

    editionCount: number;
    editionNumber: number;
    editionType: string;
    mobile?: boolean;
    artistName: string;
    title: string;
}

type ArtHeaderProps = IArtHeaderProps  & typeof actions & typeof homeActions & RouteComponentProps;
interface IArtHeaderState {
    isFavourite: boolean;
    cloneOpened: boolean;
    edition_number: number;
    public_edition_number: string;
    edition_type: string;
    editionCount: number;

    editionErrors?: string[];

    editionNumberValidated: boolean;
    editionNumberError: string;
    showDelete: boolean;
}

class ArtHeader extends React.Component<ArtHeaderProps, IArtHeaderState> {

    @resolve
    public artsDataService: ArtsDataService;

    @resolve
    public blockchainService: BlockchainService;

    @resolve
    public identityService: IdentityService;

    @resolve
    public httpService: HttpService;

    @resolve
    public toastService: ToastService;

    @resolve(ArtsDataService)
    public dataService: ArtsDataService;

    constructor(props: any) {
    super(props);
    this.state =  {
            isFavourite: false,
            cloneOpened: false,
            edition_number: this.props.editionNumber,
            editionNumberValidated: false,
            editionNumberError: "",
            public_edition_number: "",
            edition_type: "limited",
            showDelete: false,
            editionCount: this.props.editionCount,
        };
    }

    public cloneToken = () => {

        // console.log(this.state.edition_number, this.state.edition_type);

        // this.blockchainService.getLastArtworkId().then(result => {

        //     const id = parseInt(result.c[0]) + 1;

        //     this.artsDataService.getToken(this.props.id).then(state => {
        //         if(state){
        //             this.blockchainService.createArtwork(
        //                 state.title || 'Clone',
        //                 state.medium || '',
        //                 state.dimensions || '',
        //                 state.rarity || 1,
        //                 {
        //                     edition_number: this.state.edition_number || 1,
        //                     edition_count: state.edition_count || 1,
        //                     copy_of: state.blockchain_hash || '',
        //                     edition_type: this.state.edition_type
        //                 },
        //                 state.location || '',
        //             ).then(r => {
        //                 const model = {...state, ...this.state};
        //                 this.artsDataService.cloneToken(model.edition_number,
        //                      model.id, model.blockchain_hash, id, model.edition_type)
        //                      .then(r => {
        //                          this.props.history.push("/account/collection")
        //                      })
        //                      .catch(err => {
        //                          this.setState({editionErrors: err.edition_number})
        //                      })
        //             })
        //         }
        //     })

        // })
    }

    public validateAndSetEditionNumber = (number, type)  => {

        if (type === "ap") {
            this.setState({editionCount: this.artsDataService.getApMaximum(this.props.editionCount)});
        } else {
            this.setState({editionCount: this.props.editionCount});
        }

        this.setState({edition_type: type});

        this.artsDataService.getToken(this.props.id, number).then((result) => {
            if (result.valid) {
                this.setState({
                    editionNumberValidated: true,
                    edition_number: number,
                    edition_type: type,
                });
            } else {
                this.setState({
                    editionNumberValidated: false,
                    editionNumberError: result.message,
                    edition_number: number,
                });
            }

            if (number > this.props.editionCount || number <= 0) {
                this.setState({
                    editionNumberValidated: false,
                    edition_number: 1,
                    editionNumberError: `You must provide a valid edition number`,
                });
            }
        });

    }

    public getModalContent = () => {
        return (
        <React.Fragment>

          <div className="token-creation-form">

          <Grid centered={true}>
            <Col size={60}>
            <p className="token-creation-description">
                To duplicate your certificate...
            </p>
            <h1 className="token-creation-title"><strong>Modify</strong> the edition identifier of your artwork.</h1>

                <p className="clone-title">
                    {this.props.title}
                </p>

                <div style={{display: "flex", flexDirection: "column", justifyItems: "center", justifyContent: "center", alignItems: "center"}}>

                    <div style={{width: "450px", marginBottom: "90px"}}>
                        <EditionCombo
                            label="Edition number"
                            editionCount={this.state.editionCount}
                            editionNumber={this.state.edition_number}
                            editionType={this.props.editionType}
                            disabledCount={true}
                            onChangeEditionNumber={(e) =>
                                this.validateAndSetEditionNumber(e, this.state.edition_type)
                            }
                            onChangeEditionCount={(e) => console.log(e)}
                            onChangeEditionType={(e) =>
                                this.validateAndSetEditionNumber(this.state.edition_number, e.id)}
                            />
                    </div>

                    {!this.state.editionNumberValidated && <p>{this.state.editionNumberError}</p>}
                    <Button disabled={!this.state.editionNumberValidated}  onClick={this.cloneToken} presentation="light"  as={<button/>}>Duplicate certificate</Button>

                </div>

            </Col>
          </Grid>
        </div>
        </React.Fragment>
        );

    }

    public componentDidMount() {

        this.request();
        if (this.identityService.userInfo) {
            this.validateAndSetEditionNumber(this.props.editionNumber, this.props.editionType);
        }
    }

    public request = () => {
        this.artsDataService.getIsFavourite(this.props.id).then((result) => {
            this.setState({isFavourite: result});
        });
    }

    public setFavourite = () => {
        if (this.state.isFavourite) {
            this.artsDataService.disableFavourite(this.props.id).then((result) => this.request());
        } else {
            this.artsDataService.setFavourite(this.props.id).then((result) => this.request());
        }
    }

    public handleDelete = () => {
        this.setState({showDelete: !this.state.showDelete});
    }

    public deleteYes = () => {

        this.artsDataService.delete(this.props.id).then((result) => {

            this.props.history.push("/account/collection");

            this.handleDelete();
        }).catch((err) => {
            this.toastService.showToast("Error", err, "error");
        });

    }

    public render() {
        let artistName = this.props.artistName;
        if (this.props.edit) {
            if (this.identityService.userInfo) {
                artistName = this.identityService.userInfo.name;
                if (this.identityService.userInfo.last_name) { artistName += " " + this.identityService.userInfo.last_name; }
            }
        }
        const profileButton = <Button key={"profileBtn"} className={"nav-item nav-icon "} presentation="wire" leftIcon="profile"/>;
        const url = `${this.httpService.domainUrl}${this.props.location.pathname}`;
        const profileComponent = (
            <GenericDropDown
                closeOnOutside={true}
                key="profile"
                trigger={
                    <div className="iconified light action-icon">
                        <Icon type="forward" />
                    </div>
                }
            >
                <ul className={`dropdown-options show`} style={{zIndex: 999}} key="options-app">{
                    <React.Fragment>
                        <li className={`option`} key={"facebook"}>
                            <FacebookShareButton quote={"Hey! Check out this artwork on EncryptoArt! \n\n"} url={url}><label>Facebook</label></FacebookShareButton>
                        </li>
                        <li className={`option`} key={"twitter"}>
                            <TwitterShareButton title={"Hey! Check out this artwork on EncryptoArt! \n\n"} url={url}><label>Twitter</label></TwitterShareButton>
                        </li>
                    </React.Fragment>
                }</ul>
            </GenericDropDown>
        );

        return (
            <React.Fragment>
                <Modal
                    type="light"
                    visible={this.state.showDelete}
                    onCancel={this.handleDelete}
                    closeOnDimmer={true}
                    closable={true}
                    className="clone-modal"
                    size="medium"
                    >
                        <Grid centered={true} className="delete-modal">
                            <Col size={85}>
                                <h1 className="delete-title">Are you sure you want to delete this art token?</h1>
                                <Grid centered={true}>
                                    <Col size={100} className="button-group centered">
                                    <Button onClick={this.handleDelete} presentation="blueprint">No, Thanks</Button>
                                    <Button onClick={this.deleteYes} presentation="dark">Yes, Please</Button>
                                    </Col>
                                </Grid>
                            </Col>
                        </Grid>
                </Modal>
                <Modal
                    closable={true}
                    type="grey"
                    size="medium"
                    className="clone-modal"
                    onCancel={() => this.setState({cloneOpened: false})}
                    visible={this.state.cloneOpened}
                >
                    {this.getModalContent()}
                </Modal>
                <div className={`art-detail-header ${this.props.mobile ? "share-icons-mobile-container" : ""}`}>
                    {!this.props.onlyActions &&
                        <div className="share">
                            <Fade right={true}>
                                <div className="art-author">
                                    <h5 className="category">ARTIST</h5>
                                    <h5 style={{color: "black", marginBottom: 0 }}> {artistName} <img style={{ marginLeft: 10, width: 16 }} src={images.verified} alt="" /></h5>
                                </div>
                            </Fade>
                            <Fade left={true}>
                                <Divider/>
                            </Fade>
                        </div>
                    }
                    <div className="share">
                        <div className={`${this.props.mobile ? "share-icons-mobile" : "share-icons"}`}>
                            {this.props.canShare && profileComponent}
                            {this.props.canFavourite &&
                                <FavouriteButtonProps id={this.props.id}/>
                            }
                            {this.props.canClone &&
                                <a className="iconified light" style={{cursor: "pointer"}} onClick={() => this.setState({cloneOpened: true})}>
                                    <Icon faType="copy"  type="edit" />
                                </a>}
                            {this.props.canEdit &&
                            <Link to={`/art/edit/${this.props.id}`} className="iconified light">
                                <Icon type="edit" />
                            </Link>}
                            {this.props.canDelete &&
                            <a className="iconified light" style={{cursor: "pointer"}} onClick={this.handleDelete}>
                                <Icon faType="trash"  type="edit" />
                            </a>}

                    </div>
                </div>
            </div>

            </React.Fragment>
          );
    }

}

function mapStateToProps(state: IApplicationState, ownProps: any): any {
    return {
        ...ownProps,
        };
}
export default connect(mapStateToProps, {...actions, ...nameActions, ...homeActions})(withRouter(ArtHeader));



// WEBPACK FOOTER //
// ./src/components/arts/parts/art-header.tsx